import { render, staticRenderFns } from "./PosLayout.vue?vue&type=template&id=3264e8ca"
import script from "./PosLayout.vue?vue&type=script&lang=js"
export * from "./PosLayout.vue?vue&type=script&lang=js"
import style0 from "./PosLayout.vue?vue&type=style&index=0&id=3264e8ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports